 <template>


    <div  class=" sm:items-center pt-64 grid grid-rows-3 grid-flow-col gap-4">
      <h2  class="bg-black text-white text-4xl md:text-6xl font-bold pl-6 md:pl-16">About Me</h2>
      <h2 class="bg-black text-white text-xl md:text-3xl pl-6 md:pl-16 pb-8 md:pb-8 font-bold" >Check Out My Professional Journey</h2>
    </div>
    
  
<div class="pr-4 pb-12 mb-50 grid sm:mb:96 lg:grid-cols-2 sm:grid-cols-1 grid-flow-row-dense gap-14"> 
  <div class="container">
    <div id="experience-container" class="pl-4 md:pl-16">
      <div class="experience-box flex flex-col items-start p-4">
        <div class="flex items-center mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
          </svg>
          <h1 class="text-slate-100 text-2xl font-semibold ml-2">Experience</h1>
        </div>
        <div>
          <h1 class="font-bold text-lg pt-8">Research Assistant - MacEwan University / Alberta Innovates (April - August 2024)</h1>
          <ul class="list-disc m-8">
            <li>
            Assisted in research focused on developing data pipelines using the Gene Expression Omnibus to
            analyze and compare gene expression data.
            </li> 
            <li>
            Employed Python and R, utilizing Bioconductor and Biopython for analysis of complex biological
            datasets.
            </li>
            <li>
            Partnered with Alberta Innovates to meet research goals, delivering impactful results aligned with
            stakeholder expectations.
            </li>
            <li>
            Handled and analyze hundreds of gigabytes of data, improving data accessibility and
            workflow efficiency.
            </li>
          </ul>
        </div>
        <div>
          <h1 class="font-bold text-lg">Junior Software Developer - CE-Solutions (April - August 2021)</h1>
          <ul class="list-disc m-8">
           <li>
          I leveraged Vue.js to develop a set of UI components aimed at digitizing the workflow of generating
          safety forms.
          </li>
          <li>
          Implemented back end API calls in Vue.js to interface with a Firestore NoSQL database, facilitating
          seamless data retrieval and manipulation.
          </li>
          <li>
          Worked with clients to build websites for their businesses & optimize their websites for SEO.
          </li>
          <li>
          Utilized the Cypress testing framework to develop comprehensive and automated test suites,
          guaranteeing robust code quality through rigorous validation and verification processes.
          </li>
        </ul>
        </div>

      </div>
    </div>

    <div id="education-container" class="pt-4 pl-4 md:pl-16"> 
      <div class="education-box flex flex-col items-start p-4">
        <div class="flex items-center mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
          </svg>
          <h1 class="text-slate-100 text-2xl font-semibold ml-2">Education</h1>
        </div>
        <div>
          <h1 class="font-bold text-lg">Bachelor of Science in Computer Science - MacEwan University (September 2020 - June 2025)</h1>
          <p class="font-bold text-base mt-4">Relevant Courses</p>
          <p class="text-base">CMPT 496 - Final Project </p>
          <p class="text-base">CMPT 464 - Wireless Networks and Embedded Systems</p>
          <p class="text-base">CMPT 305 - Introduction to Object-Oriented Programming in Java</p>
          <p class="text-base">CMPT 395 - Introduction to Software Engineering</p>
          <p class="text-base">CMPT 380 - Computer Systems Security</p>
          <p class="text-base">CMPT 381 - Cryptology from Classical to Post-Quantum</p>
          <p class="text-base">CMPT 360 - Advanced Programming in the Unix Environment</p>
          <p class="text-base">CMPT 280 - Introduction to Computer Security</p>
          <p class="text-base">CMPT 291 - Introduction to File and Database Management</p>
          <p class="text-base">CMPT 229 - Computer Organization and Architecture </p> 
          <p class="text-base">CMPT 220 - Unix, Scripting, Linux, and Bash</p>
          <p class="text-base">CMPT 201 - Practical Programming Methodology in C</p>
          <p class="text-base">CMPT 200 - Data Structures and Algorithms</p>
          <p class="text-base">CMPT 103 - Introduction to Computing II</p>
          <p class="text-base">CMPT 101 - Introduction to Computing I</p>
        </div>
        <div>
          <br>
          <h1 class="font-bold text-lg">Web Development Certificate - Southern Alberta Institute of Technology</h1>
          <br>
          <p class="text-base">This certification covered HTML, CSS, JavaScript, PHP, MySQL, Sass, Wordpress, Adobe Photoshop, and Adobe Illustrator.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4 second-column">
    <div class="photo-box border-2 border-neutral-800 rounded-2xl lg:w-72 sm:w-full h-32 flex items-center justify-between">
      <img src="../assets/photo.png" class="rounded-full w-24 h-auto pl-3" alt="Description">
      <p class="text-base text-white m-6 ml-6">Interested in working together? Let's chat.</p>
    </div>


    <div class="m-2 resume-box border-2 border-neutral-800 rounded-2xl lg:w-72 sm:w-full h-16 flex items-center place-content-center">
      <a href="https://github.com/kiefergallant" target="_blank">
        <svg class="size-14 hover:scale-110" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
          <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(8.53333,8.53333)"><path d="M15,3c-6.627,0 -12,5.373 -12,12c0,5.623 3.872,10.328 9.092,11.63c-0.056,-0.162 -0.092,-0.35 -0.092,-0.583v-2.051c-0.487,0 -1.303,0 -1.508,0c-0.821,0 -1.551,-0.353 -1.905,-1.009c-0.393,-0.729 -0.461,-1.844 -1.435,-2.526c-0.289,-0.227 -0.069,-0.486 0.264,-0.451c0.615,0.174 1.125,0.596 1.605,1.222c0.478,0.627 0.703,0.769 1.596,0.769c0.433,0 1.081,-0.025 1.691,-0.121c0.328,-0.833 0.895,-1.6 1.588,-1.962c-3.996,-0.411 -5.903,-2.399 -5.903,-5.098c0,-1.162 0.495,-2.286 1.336,-3.233c-0.276,-0.94 -0.623,-2.857 0.106,-3.587c1.798,0 2.885,1.166 3.146,1.481c0.896,-0.307 1.88,-0.481 2.914,-0.481c1.036,0 2.024,0.174 2.922,0.483c0.258,-0.313 1.346,-1.483 3.148,-1.483c0.732,0.731 0.381,2.656 0.102,3.594c0.836,0.945 1.328,2.066 1.328,3.226c0,2.697 -1.904,4.684 -5.894,5.097c1.098,0.573 1.899,2.183 1.899,3.396v2.734c0,0.104 -0.023,0.179 -0.035,0.268c4.676,-1.639 8.035,-6.079 8.035,-11.315c0,-6.627 -5.373,-12 -12,-12z"></path></g></g>
        </svg>
      </a>
      
      <a href="https://ca.linkedin.com/in/kiefer-gallant" target="_blank">
        <svg class="ml-6 size-14 hover:scale-110" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
          <g fill="#ffffff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M41,4h-32c-2.76,0 -5,2.24 -5,5v32c0,2.76 2.24,5 5,5h32c2.76,0 5,-2.24 5,-5v-32c0,-2.76 -2.24,-5 -5,-5zM17,20v19h-6v-19zM11,14.47c0,-1.4 1.2,-2.47 3,-2.47c1.8,0 2.93,1.07 3,2.47c0,1.4 -1.12,2.53 -3,2.53c-1.8,0 -3,-1.13 -3,-2.53zM39,39h-6c0,0 0,-9.26 0,-10c0,-2 -1,-4 -3.5,-4.04h-0.08c-2.42,0 -3.42,2.06 -3.42,4.04c0,0.91 0,10 0,10h-6v-19h6v2.56c0,0 1.93,-2.56 5.81,-2.56c3.97,0 7.19,2.73 7.19,8.26z"></path></g></g>
        </svg>
      </a>
    </div>

  </div>

</div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
}

.experience-box, .education-box {
  @apply border-2 border-neutral-800 rounded-2xl bg-black text-white p-4 relative;
}

@media (min-width: 768px) {
  .experience-box, .education-box {
    padding: 1rem 2rem;
  }
} 
</style>
